import React from 'react';
import moment from 'moment';

import PopupModalContainer from '../../common/PopupModal';

import MonthItemComponent from './MonthItem';

class MonthlyRangePicker extends React.Component {
  constructor(props) {
    super(props);
    if (props.lastMonthlyDatesSelected) {
      this.state = {
        fromYear: moment(props.lastMonthlyDatesSelected.fromDate)
          .get('year')
          .toString(),
        fromMonth: moment(props.lastMonthlyDatesSelected.fromDate)
          .get('month')
          .toString(),
        toYear: moment(props.lastMonthlyDatesSelected.toDate)
          .get('year')
          .toString(),
        toMonth: moment(props.lastMonthlyDatesSelected.toDate)
          .get('month')
          .toString(),
        showMonths: false,
        fromDate: moment(),
        toDate: moment(),
        isFromDate: false,
        isToDate: false,
        show12MonthPop: false,
        popupTitle: '',
        popupMessage: '',
      };
    } else {
      this.state = {
        fromYear: (moment().get('year') - 1).toString(),
        fromMonth: moment()
          .get('month')
          .toString(),
        toYear:
          moment().get('month') > 0
            ? moment()
                .get('year')
                .toString()
            : (moment().get('year') - 1).toString(),
        toMonth: moment()
          .get('month')
          .toString(),
        showMonths: false,
        fromDate: moment(),
        toDate: moment(),
        isFromDate: false,
        isToDate: false,
        show12MonthPop: false,
        popupTitle: '',
        popupMessage: '',
      };
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.lastMonthlyDatesSelected && nextProps.lastMonthlyDatesSelected.fromDate) {
      this.setState({
        fromDate: moment(nextProps.lastMonthlyDatesSelected.fromDate).format('MMMM Do YYYY'),
        fromMonth: moment(nextProps.lastMonthlyDatesSelected.fromDate).get('month'),
      });
    }

    if (
      nextProps.lastMonthlyDatesSelected &&
      nextProps.lastMonthlyDatesSelected.toDate &&
      typeof nextProps.lastMonthlyDatesSelected.toDate.get('month') === 'number'
    ) {
      this.setState({
        toDate: moment(nextProps.lastMonthlyDatesSelected.toDate).format('MMMM Do YYYY'),
        toMonth: moment(nextProps.lastMonthlyDatesSelected.toDate).get('month'),
      });
    }
  }

  onSelectSameMonth = () => {
    if (this.state.isFromDate) {
      this.setState({ isFromDate: false, isToDate: true });
    } else {
      this.setState({ showMonths: false, isToDate: false });
      const popupTitle = 'Sorry!';
      const popupMessage = 'Please choose a date range different than the current';
      this.setState({ show12MonthPop: true, popupTitle, popupMessage });
    }
  };
  changStartDate = (m) => {
    // weird, expect a number ex, 0, instead got string jan
    let t =
      moment()
        .month(m)
        .get('month') + 1;
    const newDateObj = Object.assign({}, this.props.lastMonthlyDatesSelected);
    if (t < 10) {
      t = `0${t}`;
    }
    if (this.state.isFromDate && this.state.fromYear) {
      newDateObj.fromDate = moment(`${this.state.fromYear}${t}01`);
    } else if (this.state.isToDate && this.state.toYear) {
      newDateObj.toDate = moment(`${this.state.toYear}${t}01`).endOf('month');
    }
    if (this.state.isToDate && moment(newDateObj.toDate).diff(moment(newDateObj.fromDate), 'month') > 12) {
      const popupTitle = 'Sorry! Too many months selected';
      const popupMessage = 'Please choose a date range that is not longer than 12 months';
      this.setState({ show12MonthPop: true, popupTitle, popupMessage });
      return;
    }
    if (this.state.isToDate && moment(newDateObj.toDate).isBefore(moment(newDateObj.fromDate), 'day')) {
      const popupTitle = 'Sorry! End date should be after Start date';
      const popupMessage = 'Please choose an End date that is after Start date';
      this.setState({ show12MonthPop: true, popupTitle, popupMessage });
      return;
    }

    const { isFromDate } = this.state;
    this.props.setMonthlyDatePickerDate(newDateObj.fromDate, newDateObj.toDate, isFromDate);
    if (this.state.isFromDate) {
      this.setState({ isFromDate: false, isToDate: true });
    } else {
      this.setState({ showMonths: false, isToDate: false });
    }
  };

  changeYear = (y) => {
    if (this.state.isFromDate) {
      this.setState({
        fromYear: (parseInt(this.state.fromYear, 10) + y).toString(),
      });
    } else {
      this.setState({
        toYear: (parseInt(this.state.toYear, 10) + y).toString(),
      });
    }
  };

  closeModal = () => {
    // revert the fromDate to be the default
    this.props.setMonthlyDatePickerDate(null, null, false);
    this.setState({ show12MonthPop: false, showMonths: false });
  };

  selectMonth = (t) => {
    this.changStartDate(t);
  };

  showMonths = (startOrEnd) => {
    this.setState({ isFromDate: false, isToDate: false });
    const stateToSet = `is${startOrEnd}Date`;
    this.setState({ showMonths: !this.state.showMonths, [stateToSet]: true });
  };

  range = (start, end) =>
    Array(end - start + 1)
      .fill()
      .map((_, idx) => start + idx);

  render() {
    const months = this.range(0, 11).map((e) => moment.monthsShort(e));
    let monthBtn;
    if (months.length > 0) {
      monthBtn = months.map((month, index) => (
        <MonthItemComponent
          monthName={month}
          onSelectSameMonth={this.onSelectSameMonth}
          lastMonthlyDatesSelected={this.props.lastMonthlyDatesSelected}
          monthlyRevenueReport={this.props.monthlyRevenueReport}
          selectMonth={() => this.selectMonth(month)}
          key={month}
          monthId={index}
          fromMonth={this.state.fromMonth}
          toMonth={this.state.toMonth}
          isFromDate={this.state.isFromDate}
          isToDate={this.state.isToDate}
          style={{ display: 'flex', width: '50px', height: '40px' }}
        />
      ));
    }
    let monthSlotsClass;

    if (this.state.isFromDate) {
      monthSlotsClass = 'month-slots start';
    } else {
      monthSlotsClass = this.state.isToDate ? 'month-slots end' : 'month-slots';
    }

    return (
      <div>
        <div className="month-button-container">
          <div className="month-from-label">Start Date:</div>
          <div
            className={this.state.isFromDate ? 'month-picker-from selected' : 'month-picker-from'}
            role="button"
            tabIndex={-1}
            onClick={() => this.showMonths('From')}
          >
            {`${this.state.fromDate}`}
          </div>
          <div className="month-to-label">End Date:</div>
          <div
            role="button"
            tabIndex={-1}
            onClick={() => this.showMonths('To')}
            className={this.state.isToDate ? 'month-picker-to selected' : 'month-picker-to'}
          >
            {`${this.state.toDate}`}
          </div>
        </div>
        {this.state.showMonths && (
          <div className={monthSlotsClass}>
            <div
              className="month-picker-header"
              style={{ display: 'flex', width: '300px', justifyContent: 'space-between' }}
            >
              <button className="year-minus" onClick={() => this.changeYear(-1)}>
                &lt;
              </button>
              {this.state.isFromDate && <p>{moment(this.state.fromYear).get('year')}</p>}
              {this.state.isToDate && <p>{moment(this.state.toYear).get('year')}</p>}
              <button className="year-plus" onClick={() => this.changeYear(1)}>
                &gt;
              </button>
            </div>
            <div className="month-btn-container">{monthBtn}</div>
          </div>
        )}
        {this.state.show12MonthPop && (
          <PopupModalContainer
            popupTitle={this.state.popupTitle}
            popupMessage={this.state.popupMessage}
            buttonText="Ok"
            buttonCallback={this.closeModal}
          />
        )}
      </div>
    );
  }
}

export default MonthlyRangePicker;
